<template>
    <div class="form-group">
        <span v-if="required" class="text-danger">*</span>
        <label :for="$attrs.id">{{label}}</label>
        <template v-if="!disabled">
            <input class="form-control" :list="datalistid" v-bind="$attrs" :placeholder="placeholder" :value="value" @input="input">
            <datalist :id="datalistid">
                <slot name="list"></slot>
                <option v-for="x in datalist" :key="x.key" :label="x.value" :value="x.key"></option>
            </datalist>
        </template>
        <template v-else>
            <template v-if="$attrs.type === 'time'">
                <input class="form-control" :value="value" type="time" disabled />
            </template>
            <template v-else>
                <span class="form-control">{{value}}</span>
            </template>
        </template>
    </div>
</template>

<script>
    export default {
        name: 'formInput',
        inheritAttrs: false,
        props: ['value', 'label'],
        data: function () {
            return {
                datalist: []
            };
        },
        computed: {
            required: function () {
                return this.$attrs.required === "" || this.$attrs.required === true;
            },
            disabled: function () {
                return this.$attrs.disabled === "" || this.$attrs.disabled === true;
            },
            placeholder: function () {
                return this.$attrs.placeholder || this.label;
            },
            datalistid: function () {
                return this.$attrs.id + 'datalist';
            },
            studentlist: function () {
                return this.$attrs.student === "";
            },
            classlist: function () {
                return this.$attrs.classlist === "";
            },
            emplist: function () {
                return this.$attrs.emp === "";
            }
        },
        methods: {
            input: function (e) {
                if (this.studentlist && e.target.value != "" && !(this.datalist.length == 1 && e.target.value == this.datalist[0].StudentNo)) {
                    this.$parameter.student(e.target.value).then(x => this.datalist = x.data);
                }
                if (this.classlist) {
                    this.$parameter.class().then(x => this.datalist = x.data.Class); 
                }
                if (this.emplist && e.target.value != "" && !(this.datalist.length == 1 && e.target.value == this.datalist[0].EmpNo)) {
                    this.$parameter.emp(e.target.value).then(x => this.datalist = x.data);
                }
                this.$emit('input', e.target.value);
            },
        }
    };
</script>

<style>
</style>